export default function MemberSelect() {
	return (
		<div className="bg-white px-4 pt-4 pb-4 shadow-sm">
			Select a member to continue.
		</div>
	);
}
